import React, { useState, useEffect } from "react";
import axios from "axios";
import "./componenetStyle/Pracownicy.css";
import { useAuth } from "../auth/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const Pracownicy = () => {
    const { hasPermission } = useAuth();
    const canManageUsers = hasPermission('users_manage');
    const [pracownicy, setPracownicy] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [newPracownik, setNewPracownik] = useState({
        imie: "",
        nazwisko: "",
        email: "",
        nr_telefonu: "",
        rola: "",
    });
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({
    imie: "",
    nazwisko: "",
    email: "",
    nr_telefonu: "",
    rola: "",
    notatka: ""
    });

    const startEdit = (p) => {
        setEditingId(p.id_pracownika);
        setEditForm({
          imie: p.imie,
          nazwisko: p.nazwisko,
          email: p.email,
          nr_telefonu: p.nr_telefonu || "",
          rola: p.rola || "",
          notatka: p.notatka || ""
        });
      };
      
      const cancelEdit = () => {
        setEditingId(null);
        setEditForm({ imie:"", nazwisko:"", email:"", nr_telefonu:"", rola:"", notatka:"" });
      };
      
      const saveEdit = async () => {
                if (!canManageUsers) return;
        try {
          const token = localStorage.getItem("token");
          const res = await axios.put(
            `${API_URL}/pracownicy/${editingId}`,
            editForm,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setPracownicy(pracownicy.map(p => p.id_pracownika === editingId ? res.data : p));
          cancelEdit();
        } catch (err) {
          console.error("Błąd edycji pracownika:", err);
          alert("Nie udało się zapisać zmian.");
        }
      };

    useEffect(() => {
    const fetchPracownicy = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                throw new Error("Brak tokena autoryzacyjnego");
            }

            const response = await axios.get(`${API_URL}/pracownicy`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPracownicy(response.data);
        } catch (err) {
            console.error("Błąd pobierania pracowników:", err);
            setError("Nie udało się pobrać listy pracowników.");
        } finally {
            setLoading(false);
        }
    };

    fetchPracownicy();
}, []);

    const handleChange = (e) => {
        setNewPracownik({ ...newPracownik, [e.target.name]: e.target.value });
    };

    const handleEditChange = e => {
        setEditForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
      };

    const handleAddPracownik = async (e) => {
        if (!canManageUsers) return;
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                throw new Error("Brak tokena autoryzacyjnego");
            }
    
            const response = await axios.post(`${API_URL}/pracownicy`, newPracownik, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            setPracownicy([...pracownicy, response.data]);
            setShowForm(false);
        } catch (err) {
            console.error("Błąd dodawania pracownika:", err);
            alert("Nie udało się dodać pracownika.");
        }
    };
    

    const handleEdit = (id) => {
        // Przekierowanie do edycji pracownika (przygotowanie w przyszłości)
        console.log(`Edytowanie pracownika o ID: ${id}`);
    };
    
    const handleDelete = async (id) => {
        if (!canManageUsers) return;
        if (window.confirm("Czy na pewno chcesz usunąć tego pracownika?")) {
            try {
                const token = localStorage.getItem("token");
                if (!token) {
                    throw new Error("Brak tokena autoryzacyjnego");
                }
    
                await axios.delete(`${API_URL}/pracownicy/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
    
                setPracownicy(pracownicy.filter(pracownik => pracownik.id_pracownika !== id));
            } catch (err) {
                console.error("Błąd usuwania pracownika:", err);
                alert("Nie udało się usunąć pracownika.");
            }
        }
    };
    
    if (loading) return <p>Ładowanie...</p>;
    if (error) return <p className="error">{error}</p>;

    return (
        <div className="pracownicy-container">
            <h2>Lista pracowników</h2>
            {canManageUsers ? <button className="add-button" onClick={() => setShowForm(true)}>Dodaj pracownika</button> : null}
    
            {showForm && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>Dodaj nowego pracownika</h3>
                        <form onSubmit={handleAddPracownik} className="form-container">
                            <input type="text" placeholder="Imię" name="imie" onChange={handleChange} required />
                            <input type="text" placeholder="Nazwisko" name="nazwisko" onChange={handleChange} required />
                            <input type="email" placeholder="Email" name="email" onChange={handleChange} required />
                            <input type="text" placeholder="Telefon" name="nr_telefonu" onChange={handleChange} />
                            <div className="select-container">
                                <label>Stanowisko:</label>
                                <select name="rola" onChange={handleChange} required>
                                    <option value="">Wybierz</option>
                                    <option value="technik">Technik</option>
                                    <option value="administrator">Administrator</option>
                                    <option value="manager">Manager</option>
                                    <option value="koordynator">Koordynator</option>
                                    <option value="pomocnik">Pomocnik</option>
                                </select>
                            </div>


                            <div className="button-group">
                                <button type="submit" className="save-btn">Dodaj</button>
                                <button type="button" className="cancel-btn" onClick={() => setShowForm(false)}>Anuluj</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

    
            <table className="pracownicy-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Imię</th>
                        <th>Nazwisko</th>
                        <th>Email</th>
                        <th>Telefon</th>
                        <th>Stanowisko</th>
                        <th>Akcje</th>
                    </tr>
                </thead>
                <tbody>
                {pracownicy.map((p) => (
                    <tr key={p.id_pracownika}>
                        {editingId === p.id_pracownika ? (
                        <>
                            <td>{p.id_pracownika}</td>
                            <td><input name="imie"        value={editForm.imie}        onChange={handleEditChange} /></td>
                            <td><input name="nazwisko"    value={editForm.nazwisko}    onChange={handleEditChange} /></td>
                            <td><input name="email"       value={editForm.email}       onChange={handleEditChange} /></td>
                            <td><input name="nr_telefonu" value={editForm.nr_telefonu} onChange={handleEditChange} /></td>
                            <td>
                            <select name="rola" value={editForm.rola} onChange={handleEditChange}>
                                <option value="">— wybierz —</option>
                                <option value="technik">Technik</option>
                                <option value="administrator">Administrator</option>
                                <option value="manager">Manager</option>
                                <option value="koordynator">Koordynator</option>
                                <option value="pomocnik">Pomocnik</option>
                            </select>
                            </td>
                            <td className="actions">
                            {canManageUsers ? <button onClick={saveEdit}>Zapisz</button> : null}
                            {canManageUsers ? <button onClick={cancelEdit}>Anuluj</button> : null}
                            </td>
                        </>
                        ) : (
                        <>
                            <td>{p.id_pracownika}</td>
                            <td>{p.imie}</td>
                            <td>{p.nazwisko}</td>
                            <td>{p.email}</td>
                            <td>{p.nr_telefonu || "-"}</td>
                            <td>{p.rola || "-"}</td>
                            <td className="actions">
                            {canManageUsers ? <button onClick={() => startEdit(p)}>Edytuj</button> : null}
                            {canManageUsers ? <button onClick={() => handleDelete(p.id_pracownika)}>Usuń</button> : null}
                            </td>
                        </>
                        )}
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
    
};

export default Pracownicy;
